import React from 'react'
import { Container } from 'react-pixi-fiber'
import SpineRenderer from './spineRenderer'

export default class Spine extends React.Component {
  rearrangeChildren = () => {
    // This is necessary because pixi-spine deletes children
    // when it instantiates the sprites in the spine, therefore
    // we need to wrap it inside a container and make the "children"
    // actually siblings of the spine itself
    const {
      children,
      x = 0,
      y = 0,
      anchor = 0,
      scale = {x: 1, y: 1},
      skew = {x: 0, y: 0},
      rotation = 0
    } = this.props
    const newProps = { ...this.props, children: undefined }
    return (
      <Container
        x={x}
        y={y}
        anchor={anchor}
        scale={scale}
        rotation={rotation}
        skew={skew}
      >
        <SpineRenderer
          {...newProps}
          anchor={0}
          scale={{ x: 1, y: 1 }}
          x={0}
          y={0}
          skew={{ x: 0, y: 0 }}
          onCreate={() => this.forceUpdate()}
          ref={ref => this.spineRenderer = ref}
        />
        {
          React.Children.map(
            children,
            child => child && React.cloneElement(child, { spine: this.spineRenderer })
          )
        }
      </Container>
    )
  }

  render() {
    return this.props.children
      ? this.rearrangeChildren()
      : <SpineRenderer {...this.props} ref={ref => this.spineRenderer = ref} />
  }
}
